import React, {useState} from "react";
import { ModalBuilder, Lookup } from "@redriver/cinnamon";
import { PermissionCheck } from "features/../../../shared/components/auth";
import {Actions, Targets} from "features/../../../shared/constants/permissions";
import { IconButton } from "features/../../../shared/components/buttons";
import Add from "features/../../../shared/assets/white-add.svg";
import { LookupTypes } from "features/../../../shared/features/Settings";
import ServiceForm from "./ServiceForm";
import { TranslatedModal } from "../../../components/modals";

const AddServiceModal = ({ submitAction, onSubmitted, dealerOfficeId }) => {
    const [uploadDoc, setUploadDoc] = useState(null);

    const onChangeUpload = (file) => {
        let fileReader = new FileReader();
        fileReader.onload = () => {
            const res = fileReader.result;
            setUploadDoc(res);
        };
        fileReader.readAsDataURL(file);
    };
    return(
  <PermissionCheck target={Targets.Service} action={Actions.Create}>
      <ModalBuilder
        withForm
        submitAction={submitAction}
        submitParams={{ dealerOfficeId, uploadDoc }}
        onSubmitted={onSubmitted}
        renderTrigger={showModal => (
          <IconButton
            icon={Add}
            primary
            content="New Service"
            onClick={showModal}
          />
        )}
        renderModal={(modalProps, formProps) => (
          <TranslatedModal.Add
            {...modalProps}
            size="small"
            header="Add Quarterly Service"
            submitLabel="Create Quarterly Service"
          >
            <ServiceForm
              formProps={formProps}
              onChangeUpload={onChangeUpload}
            />
          </TranslatedModal.Add>
        )}
      />
  </PermissionCheck>
)};

export default AddServiceModal;
